module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[74]561.f393958.woff2";